import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { firestore } from './../../firebase/firebase';
import { Station } from './../../models/Station';
import firebase from 'firebase';

export const GET_STATION_LOADING = 'GET_STATION_LOADING';
export const GET_STATION_SUCCESS = 'GET_STATION_SUCCESS';
export const GET_STATION_FAILED = 'GET_STATION_FAILED';

export const CREATE_STATION_LOADING = 'CREATE_STATION_LOADING';
export const CREATE_STATION_SUCCESS = 'CREATE_STATION_SUCCESS';
export const CREATE_STATION_FAILED = 'CREATE_STATION_FAILED';

export const SHOW_SNACKBAR = 'SHOW_SNACKBAR';

interface ShowSnackBar {
  type: typeof SHOW_SNACKBAR;
}

interface StationLoading {
  type: typeof GET_STATION_LOADING;
}

interface StationError {
  type: typeof GET_STATION_FAILED;
  payload: {
    error: string;
  };
}

interface StationSuccess {
  type: typeof GET_STATION_SUCCESS;
  payload: {
    stations: Station[];
  };
}

interface CreateStationLoading {
  type: typeof CREATE_STATION_LOADING;
}

interface CreateStationError {
  type: typeof CREATE_STATION_FAILED;
  payload: {
    error: string;
  };
}

interface CreateStationSuccess {
  type: typeof CREATE_STATION_SUCCESS;
  payload: {
    docId: string;
  };
}

export type StationActionTypes =
  | ShowSnackBar
  | StationLoading
  | StationError
  | StationSuccess
  | CreateStationLoading
  | CreateStationSuccess
  | CreateStationError;

export const showSnackbar = (shouldShow: boolean) => {
  return { type: SHOW_SNACKBAR };
};

const getStationsSuccess = (stations: Station[]): StationSuccess => {
  return {
    type: GET_STATION_SUCCESS,
    payload: {
      stations,
    },
  };
};

//Create Station
const createStationLoading = (): CreateStationLoading => {
  return { type: CREATE_STATION_LOADING };
};

const createStationError = (error: string): CreateStationError => {
  return {
    type: CREATE_STATION_FAILED,
    payload: {
      error,
    },
  };
};

const createStationsSuccess = (docId: string): CreateStationSuccess => {
  return {
    type: CREATE_STATION_SUCCESS,
    payload: { docId },
  };
};

export const createStation = (name: string, address: string) => {
  return (dispatch: ThunkDispatch<{}, {}, AnyAction>) => {
    dispatch(createStationLoading());
    firestore
      .collection('stations')
      .add({
        name,
        address,
        timestamp: firebase.firestore.FieldValue.serverTimestamp(),
      })
      .then((docRef) => {
        dispatch(createStationsSuccess(docRef.id));
      })
      .catch((error) => {
        console.error(error);
        dispatch(createStationError(error.message));
      });
  };
};

export const getStations = () => {
  return async (dispatch: ThunkDispatch<{}, {}, AnyAction>) => {
    // dispatch(loading());
    return firestore
      .collection('stations')
      .orderBy('timestamp', 'desc')
      .get()
      .then((querySnapshot) => {
        return querySnapshot.docs.map(
          (doc) =>
            new Station(
              doc.id,
              doc.data().stationName,
              doc.data().stationAddress,
              doc.data().stationPostcode,
              doc.data().stationState,
              doc.data().companyId,
              doc.data().companyName
            )
        );
      })
      .then((stations) => {
        dispatch(getStationsSuccess(stations));
      });
    // .catch((error) => {
    //   console.error(error);
    //   dispatch(getStationError(error.message));
    // });
  };
};
